<button
  mat-icon-button
  (click)="downloadFile()"
  *ngIf="!options && fileType !== 'txt'"
>
  <mat-icon
    fontIcon="bosch-ic-download"
    [matTooltip]="tooltip"
    [matTooltipPosition]="positionTooltip"
  ></mat-icon>
</button>
<button mat-button (click)="downloadFile()" *ngIf="fileType === 'txt'">
  {{ "export-txt" | translate }}
</button>
<button
  mat-icon-button
  [matMenuTriggerFor]="menu"
  *ngIf="options && fileType !== 'txt'"
>
  <mat-icon
    fontIcon="bosch-ic-download"
    [matTooltip]="tooltip"
    [matTooltipPosition]="positionTooltip"
  ></mat-icon>
</button>
<mat-menu #menu="matMenu">
  <button
    *ngFor="let option of options"
    mat-menu-item
    (click)="downloadFile(option)"
  >
    {{ option.name }}
  </button>
</mat-menu>
